import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$stateProvider',
  function (runtimeConstant, $stateProvider) {
    function run() {
      try {
        $stateProvider
          .state('modules.nfe', {
            url: '/nfe',
            templateUrl: 'views/modules/nfe/nfe.html',
            controller: 'nfeController',
            redirectTo: 'modules.nfe.nfes',
            data: {
              title: 'NFES',
              permissions: {
                only: ['ADMIN', 'ManageNFes'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'nfeService',
            },
          })
          .state('modules.nfe.nfes', {
            url: '/nfes',
            templateUrl: 'views/modules/nfe/nfeList.html',
            controller: 'nfeListController',
            data: {
              title: 'NFES',
              states: {
                new: 'modules.nfe.nfes-new',
                nfe: 'modules.nfe.nfes',
              },
              permissions: {
                only: ['ADMIN', 'ManageNFes'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'nfeService',
            },
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
